module.exports = __webpack_public_path__ + "img/home-banner.bafee80e.jpg";